import useSWR from 'swr';
import { SWRConfiguration } from 'swr/_internal';
import { useMemo } from 'react';

// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// types

import { ISetting } from 'src/types/DTO/setting/ISetting';

// ----------------------------------------------------------------------

// XỬ LÝ API CÀI ĐẶT

// ----------------------------------------------------------------------

export function useGetSetting(option?: SWRConfiguration) {
  const URL = endpoints.setting.root;

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher, option);

  const librarySetting = data?.data;
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          ...librarySetting,
        } as ISetting,
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
// ----------------------------------------------------------------------

export async function updateSetting(formData: any) {
  const URL = endpoints.setting.update;

  const { data } = await axios.put(URL, formData);

  return data;
}
